import { Injectable } from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class SignUpDataTransferService {

  userInformationId: any = 0;
  email = "";
  password = "";
  companySummaryInformation = {
    companyName: '',
    firstName: '',
    lastName: '',
    email: '',
    cellPhone: '',
    officePhone: '',
    billingEmail: '',
    address: '',
    city: '',
    stateTypeId: '',
    zip: '',
    isApprover: '',
    receiveInvoice: '',
    receiveBreakdownCommunication: ''
  }

  setCompanySummaryInformation(companyInformation) {
    sessionStorage.setItem("companyInformation.email", companyInformation.email);
    sessionStorage.setItem("companyInformation.firstname", companyInformation.firstname);
    sessionStorage.setItem("companyInformation.lastname", companyInformation.lastname);
    sessionStorage.setItem("companyInformation.officePhone", companyInformation.officePhone);
    sessionStorage.setItem("companyInformation.phone", companyInformation.phone);
    sessionStorage.setItem("companyInformation.email", companyInformation.email);
    sessionStorage.setItem("companyInformation.billingEmail", companyInformation.billingEmail);
    sessionStorage.setItem("companyInformation.companyName", companyInformation.companyName);
    sessionStorage.setItem("companyInformation.address", companyInformation.address);
    sessionStorage.setItem("companyInformation.city", companyInformation.city);
    sessionStorage.setItem("companyInformation.stateTypeId", companyInformation.stateTypeId);
    sessionStorage.setItem("companyInformation.zip", companyInformation.zip);
    sessionStorage.setItem("companyInformation.password", companyInformation.password);
    sessionStorage.setItem("companyInformation.isApprover", companyInformation.isApprover);
    sessionStorage.setItem("companyInformation.receiveInvoice", companyInformation.receiveInvoice);
    sessionStorage.setItem("companyInformation.receiveBreakdownCommunication", companyInformation.receiveBreakdownCommunication);

  }

  getCompanySummaryInformation() {
    this.companySummaryInformation.email = sessionStorage.getItem("companyInformation.email");
    this.companySummaryInformation.firstName = sessionStorage.getItem("companyInformation.firstname");
    this.companySummaryInformation.lastName = sessionStorage.getItem("companyInformation.lastname");
    this.companySummaryInformation.officePhone = sessionStorage.getItem("companyInformation.officePhone");
    this.companySummaryInformation.cellPhone = sessionStorage.getItem("companyInformation.phone");
    this.companySummaryInformation.email = sessionStorage.getItem("companyInformation.email");
    this.companySummaryInformation.billingEmail = sessionStorage.getItem("companyInformation.billingEmail");
    this.companySummaryInformation.companyName = sessionStorage.getItem("companyInformation.companyName");
    this.companySummaryInformation.address = sessionStorage.getItem("companyInformation.address");
    this.companySummaryInformation.city = sessionStorage.getItem("companyInformation.city");
    this.companySummaryInformation.stateTypeId = sessionStorage.getItem("companyInformation.stateTypeId");
    this.companySummaryInformation.zip = sessionStorage.getItem("companyInformation.zip");
    this.companySummaryInformation.isApprover = sessionStorage.getItem("companyInformation.isApprover");
    this.companySummaryInformation.receiveInvoice = sessionStorage.getItem("companyInformation.receiveInvoice");
    this.companySummaryInformation.receiveBreakdownCommunication = sessionStorage.getItem("companyInformation.receiveBreakdownCommunication");
    return this.companySummaryInformation;
  }

  resetCompanySummaryInformation() {
    this.companySummaryInformation = {
      companyName: '',
      firstName: '',
      lastName: '',
      email: '',
      cellPhone: '',
      officePhone: '',
      billingEmail: '',
      address: '',
      city: '',
      stateTypeId: '',
      zip: '',
      isApprover: '',
      receiveInvoice: '',
      receiveBreakdownCommunication: ''
    }

    sessionStorage.removeItem("companyInformation.email");
    sessionStorage.removeItem("companyInformation.firstname");
    sessionStorage.removeItem("companyInformation.lastname");
    sessionStorage.removeItem("companyInformation.officePhone");
    sessionStorage.removeItem("companyInformation.phone");
    sessionStorage.removeItem("companyInformation.email");
    sessionStorage.removeItem("companyInformation.companyName");
    sessionStorage.getItem("companyInformation.address");
    sessionStorage.getItem("companyInformation.city");
    sessionStorage.getItem("companyInformation.stateTypeId");

  }

  getEmailEntered() {
    return this.email;
  }

  setEmail(email) {
    this.email = email;
  }
}
